var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.alerts),function(alert,index){return _c('div',{key:index,staticClass:"alert",class:("alert-" + (alert.type))},[_vm._v("\n    "+_vm._s(alert.message)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }